import {
  InformationPanel,
  useIsDesktop,
} from '@eCommerce/frontend-legacy-shared-library-native';
import {Pressable, Text} from 'native-base';
import React from 'react';
import {Linking} from 'react-native';

import {supportPhoneNumber} from 'models/supportPhoneNumber';
import {useTheme} from 'styled-components/native';
import {useFontFamily} from 'hooks/useFontFamily';

const OffersErrorDisplay = () => {
  const theme = useTheme();
  const {tuna} = theme.colors;
  const bodyFontFamily = useFontFamily('body', 400);
  const isDesktop = useIsDesktop();
  const upperDescriptionText =
    "A system error occurred, but we're working on it. Try to refresh the page.";
  const lowerDescriptionText = (
    <Text
      color={tuna}
      fontFamily={bodyFontFamily}
      /* Bit of a hack: normally we'd use fontFamily "body" but native base is not theming these correctly when passed into the shared lib */
      fontSize="14px"
      lineHeight={isDesktop ? '30px' : '24px'}>
      If it&apos;s still an issue, call{' '}
      <Pressable
        _hover={{textDecoration: 'underline'}}
        onPress={() => Linking.openURL(`tel:${supportPhoneNumber}`)}>
        <Text
          color={tuna}
          fontFamily={bodyFontFamily}
          fontSize="14px"
          bold
          lineHeight={isDesktop ? '30px' : '24px'}>
          {supportPhoneNumber}
        </Text>
      </Pressable>
    </Text>
  );

  return (
    <InformationPanel
      hasShadow={true}
      isSVG={false}
      iconName="exclamation-circle"
      iconSize={{height: 72, width: 72}}
      iconIsLight={true}
      iconColor="#D60000"
      titleText="Well, this is embarrassing."
      upperDescriptionText={upperDescriptionText}
      lowerDescriptionText={lowerDescriptionText}
    />
  );
};
export default OffersErrorDisplay;
